module.exports = __webpack_public_path__ + "static/media/fernando3.0294e6fa.jpg";